import {
  type EmbeddedReportElement,
  Tool,
  type ToolArgs,
  isEmbeddedReportElement,
  slate,
} from '@aha-app/aha-editor-v2';
import { openReport } from 'components/Dashboards/helpers';

class ToolOpenReport extends Tool {
  static toolName = 'Open report';
  static iconClass = 'aha-icon aha-icon-open-view';

  static available({ editor, element }: ToolArgs) {
    const report = this.reportElement({ editor, element });
    if (report?.payload?.type && report.payload.type !== 'ExtensionPanel') {
      return true;
    }

    return false;
  }

  static action({ editor, element }: ToolArgs): void {
    const report = this.reportElement({ editor, element });
    if (report) {
      openReport(report.payload);
    }
  }

  static reportElement({
    editor,
    element,
  }: ToolArgs): EmbeddedReportElement | undefined {
    if (element && isEmbeddedReportElement(element)) {
      return element;
    } else {
      const reports = slate.Editor.above(editor, {
        match: isEmbeddedReportElement,
      });

      if (reports) {
        return reports[0];
      }
    }
  }
}

export default ToolOpenReport;
